// Google Ads Conversion Tracking Utilities

/**
 * Track a conversion event in Google Ads
 * @param {string} conversionLabel - The conversion label from Google Ads
 * @param {number} value - The conversion value (e.g., order total)
 * @param {string} currency - Currency code (default: INR)
 */
export const trackConversion = (conversionLabel, value = 0, currency = 'INR') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': `AW-17779376991/${conversionLabel}`,
      'value': value,
      'currency': currency
    });
    console.log(`Conversion tracked: ${conversionLabel}, Value: ${value} ${currency}`);
  }
};

/**
 * Track page views
 * @param {string} pagePath - The page path
 * @param {string} pageTitle - The page title
 */
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
};

/**
 * Track custom events
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Event parameters
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

/**
 * Pre-configured conversion tracking functions
 */
export const ConversionEvents = {
  // Track when user completes purchase
  // You'll need to get the actual conversion label from Google Ads
  trackPurchase: (orderValue) => {
    trackConversion('CONVERSION_LABEL_HERE', orderValue, 'INR');
  },
  
  // Track when user adds to cart
  trackAddToCart: (productValue) => {
    trackEvent('add_to_cart', {
      currency: 'INR',
      value: productValue
    });
  },
  
  // Track when user views product
  trackProductView: (productId, productName) => {
    trackEvent('view_item', {
      items: [{
        item_id: productId,
        item_name: productName
      }]
    });
  },
  
  // Track when user starts checkout
  trackBeginCheckout: (cartValue) => {
    trackEvent('begin_checkout', {
      currency: 'INR',
      value: cartValue
    });
  },
  
  // Track contact form submission
  trackContactForm: () => {
    trackEvent('generate_lead', {
      event_category: 'engagement',
      event_label: 'contact_form_submission'
    });
  }
};
